export default __webpack_public_path__ + "static/media/e-learning.b004ded3.svg";